<template>
  <div class="results">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>Scenarios</h1>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="container">
        <div class="col-md-6 column">
          <p>
            C19UDM offers four scenarios based on different assumptions about
            how COVID 19 might develop over the next couple of years. The most
            important differences are concerned with future effective treatments
            and a vaccine.
          </p>
        </div>
      </div>
    </div>
    <div class="widget bottom-widget">
      <div class="container">
        <template
          v-if="currentRun.getScenario() && currentRun.getScenario().name"
        >
          <section class="gray-widget-box selected">
            <h5>You selected: {{ currentRun.getScenario().title }}</h5>
            <p>{{ currentRun.getScenario().description }}</p>
            <div>
              <a
                href="/"
                class="btn btn-info"
              >
                Start again
              </a>
              &nbsp;
              <router-link
                to="/interventions"
                class="btn btn-primary"
              >
                Select interventions
              </router-link>
            </div>
          </section>
        </template>
        <template v-else>
          <template v-for="scenario in scenarios">
            <div
              :key="scenario.name"
              class="col-md-3"
            >
              <section class="gray-widget-box">
                <h5>{{ scenario.title }}</h5>
                <p>{{ scenario.description }}</p>
                <div class="lockdown-chart">
                  Click
                  <a
                    :href="'.' + scenario.lockdownChart"
                    target="_blank"
                  >here</a>
                  to see how lockdown intensity varies over time.
                </div>
                <div class="text-center">
                  <button
                    class="btn btn-primary"
                    @click="chooseScenario(scenario)"
                  >
                    Select Scenario
                  </button>
                </div>
              </section>
            </div>
          </template>
        </template>
        <div class="clearfix" />
      </div>
    </div>
    <div class="widget bottom-widget">
      <div class="container">
        <div class="pull-right">
          <router-link
            to="/"
            class="btn btn-primary"
          >
            Return
          </router-link>
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import data from "../services/data";
import router from "../router";

export default {
  data() {
    return {
      sharedStorage: this.$root.$data.sharedStorage,
      scenarios: data.scenarios,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun()
    };
  },
  methods: {
    chooseScenario(scenario) {
      const currentRun = this.sharedStorage.getCurrentRun();
      currentRun.setScenario(scenario);

      router.push({ path: "/interventions" });
    }
  }
};
</script>

<style lang="scss">
.gray-widget-box {
  padding: 30px 20px;
}
.gray-widget-box.selected {
  text-align: left;
  h5 {
    text-align: left;
  }
  p {
    min-height: auto;
    text-align: left;
    margin: 25px 0;
  }
}
.lockdown-chart {
  margin: 0 0 30px 20px;
}
</style>
